import { render, staticRenderFns } from "./ListTaskHooks.vue?vue&type=template&id=4319a5ec"
import script from "./ListTaskHooks.vue?vue&type=script&lang=js"
export * from "./ListTaskHooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports